import React from 'react';
import { useHistory } from 'react-router';

import NotFoundRocket from '../../assets/not_found_rocket.svg';
import './NotFound.scss';
import Button from '../../components/Button/Button';
import { RouterPaths } from '../../constants/routes';
import { Footer } from '../../components/Footer';
import AuthService from '../../services/AuthService';
import DSLogo from '../../assets/DataswiftLogo';
import { AUTH_LOGIN_URL } from '../../app-config';

type PropsType = {
  path?: string;
  default?: boolean;
};

const NotFoundPage: React.FC<PropsType> = () => {
  const history = useHistory();
  const onLogoClick = () => history.push(RouterPaths.home);
  const onButtonClick = () => {
    if (AuthService.loggedIn()) history.push(RouterPaths.dashboard);
    else window.location.assign(AUTH_LOGIN_URL);
  };

  return (
    <div className="ds-404-wrapper">
      <div className="ds-404-page">
        <div className="ds-logo" onClick={onLogoClick}>
          <DSLogo fill="#F5F6FA" />
        </div>

        <div className="ds-404-content">
          <img src={NotFoundRocket} alt="Not Found" />
          <div className="ds-404-ellipsis">
            <div className="text-title">404</div>
            <div className="text-title-normal">Page not found</div>
            <Button className="ds-app-button" text="Return" onClick={onButtonClick} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
